import { connect } from 'react-redux';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { actions, Control, LocalForm } from 'react-redux-form';
import ValidationErrors from '../forms/ValidationErrors';
import ModalComponent from '../ModalComponent';
import {
  contractFees, chargeRules, modals, flashMessages
} from '../../ducks';
import ControlGroup from '../forms/ControlGroup';
import './styles/ContractFeeModal.scss';


let formDispatch;

const ContractRuleModal = ({
  onClose,
  onSave,
  onUnexpectedError,
  contractRule,
  reloadContractFees,
  contractFee,
  showFlash
}) => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  if (contractRule !== undefined) {
    contractRule.test = contractRule.test || '';
  }

  const initialState = {
    contractRule,
    contractFee
  };


  const showSuccessMessage = (contractRuleObject) => {
    let message;
    if (contractRuleObject.id) {
      message = `Contract rule "${contractRuleObject.description}" has been edited.`;
    } else {
      message = `Contract rule "${contractRuleObject.description}" has been created.`;
    }

    showFlash({ message });
  };

  return (
    <LocalForm
      model='contract_fee'
      initialState={initialState}
      onSubmit={
        values => {
          setLoading(true);
          onSave(values.contractRule)
            .then(onClose)
            .then(reloadContractFees)
            .then(() => showSuccessMessage(values.contractRule))
            .catch(response => {
              setLoading(false);
              if (response.contract_rule && response.contract_rule.errors) {
                setErrors(response.contract_rule.errors);
              } else {
                onClose();
                onUnexpectedError();
              }
            });
        }
      }
      getDispatch={(dispatch) => {
        formDispatch = dispatch;
      }}

    >

      <ModalComponent
        title={contractRule.id ? 'Edit Contract Rule Details' : 'Add Contract Rule Details'}
        buttons={[
          <input
            className='btn btn-primary'
            type='submit'
            disabled={loading}
            value={loading ? 'Saving...' : 'Save'}
            onClick={() => formDispatch(actions.submit('contract_fee'))}
          />
        ]}
      >
        <div className='form-horizontal'>
          <ValidationErrors errors={errors} />

          <ControlGroup label='Description' key='description' errors={errors.description} showErrors>
            <Control.text model='.contractRule.description' placeholder='e.g. description' className='w-100' />
          </ControlGroup>

          <ControlGroup label='Rule' key='rule' errors={errors.test} showErrors>
            <Control.textarea
              model='.contractRule.test'
              placeholder='e.g. test'
              className='w-100'
            />
          </ControlGroup>

          <ControlGroup label='Contract Fee' key='contract_fee'>
            <Control.text model='.contractFee.name' placeholder='e.g. Contract Fee' className='w-100' disabled />
          </ControlGroup>

          <ControlGroup label='Active' key='active' errors={errors.active} showErrors>
            <Control.checkbox model='.contractRule.active' className='form-check-inline' />
          </ControlGroup>
        </div>
      </ModalComponent>

    </LocalForm>
  );
};

ContractRuleModal.propTypes = {
  /** Billing categories a charge/credit can be added to */
  billingCategories: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })),

  contractRule: PropTypes.shape({
    id: PropTypes.string,
    customer_id: PropTypes.string,
    description: PropTypes.string,
    test: PropTypes.string,
    active: PropTypes.bool
  }),

  showFlash: PropTypes.func

};

const mapDispatchToProps = (dispatch) => ({
  reloadContractFees: () => dispatch(contractFees.actions.markDirty()),
  onSave: (contractRule) => {
    if (contractRule.id !== undefined) {
      return dispatch(chargeRules.actions.update(contractRule, { id: contractRule.id }));
    }
    return dispatch(chargeRules.actions.create(contractRule));
  },
  onClose: () => dispatch(modals.actions.hide()),
  onUnexpectedError: () => dispatch(modals.actions.show('UnexpectedError')),
  showFlash: (props) => dispatch(flashMessages.actions.show(props))
});

ContractRuleModal.defaultProps = {
  contractRule: {},
  showFlash: () => false
};

export default connect(null, mapDispatchToProps)(ContractRuleModal);
